export const ZERO = 0
export const ONE = 1
export const TWO = 2
export const MINUS_ONE = -1
export const THREE = 3
export const FOUR = 4
export const FIVE = 5
export const FOURTEEN = 14
export const FIFTEEN = 15
export const SIX = 6
export const EIGHT = 8
export const TEN = 10
export const TWELVE = 12
export const SIXTEEN = 16
export const EIGHTEEN = 18
export const NINETEEN = 19
export const TWENTY = 20
export const THIRTY = 30
export const FORTY = 40
export const TWENTY_TWO = 22
export const TWENTY_FOUR = 24
export const FIFTY = 50
export const SIXTY = 60
export const SEVENTY = 70
export const ONE_TWO_FIVE = 125
export const ONE_HUNDRED = 100
export const ONE_THOUSAND = 1000
export const ONE_HUNDRED_TWENTY = 120
export const TWO_HUNDRED = 200
export const TWO_FOUR_ZERO = 240
export const FIVE_TWENTY = 520
export const SEVEN_SIX_EIGHT = 768
export const EIGHT_HUNDRED = 800
export const THOUSAND = 1000
export const ONE_ZERO_TWO_FOUR = 1024
export const EIGHTEEN_HUNDRED = 1800
export const TWENTY_SECONDS = 20000
export const THIRTY_SECONDS = 30000
export const EIGHTEEN_MINUTES = 1.08e+6
export const TWENTY_MINUTES = 1.2e+6
export const TWO_FOUR_FIVE_ZERO = 2450
export const THREE_NINE_ZERO = 390
export const MOBILE = 768
export const ONE_HOUR = 3.6e+6
export const FIFTY_EIGHT_MINUTES = 3.48e+6
export const VIEWPORT_HEIGHT_MULTIPLIER = 0.3
